export default __webpack_public_path__ + "static/media/Inter-Regular.0be946bd.woff";